module.exports = __webpack_public_path__ + "img/search_blank.a1e6fc5d.png";